<div class="performance-tracking-container">
  <h2 class="component-title">
    <mat-icon>trending_up</mat-icon>
    {{ title }}
  </h2>

  <!-- Overall Performance Scores -->
  @if(overallScores.length > 0){
  <div class="section">
    <h3 class="section-title">
      <mat-icon>dashboard</mat-icon>
      Overall Performance Overview
    </h3>
    <app-score-cards [universities]="overallScores" [metrics]="['Overall Performance Score']"
      [title]="'Performance Scores'">
    </app-score-cards>
  </div>
  }

  <!-- Performance Radar Chart -->
  @if(performanceRadarData.length > 0){
  <div class="section">
    <h3 class="section-title">
      <mat-icon>radar</mat-icon>
      Performance Metrics Comparison
    </h3>
    <app-polar-chart [polarChartData]="performanceRadarData">
    </app-polar-chart>
  </div>
  }

  <!-- Performance Table -->
  @if(hasPerformanceData()){
  <div class="section" >
    <h3 class="section-title">
      <mat-icon>table_chart</mat-icon>
      Detailed Performance Metrics
    </h3>
    <div class="table-container">
      <app-table [dataSource]="performanceTableData" [columns]="performanceTableColumns"
        [displayedColumns]="getPerformanceTableColumns()">
      </app-table>

    </div>
  </div>
  }

  <!-- Performance Comparison Pie Charts using reusable component -->
  <app-pie
    [tabName]="'Performance Tracking'"
    [universitiesData]="getUniversitiesForPieCharts()"
    [metrics]="getPerformanceMetrics()"
    [chartSize]="[250, 250]"
    [showAnimations]="false"
    [colorScheme]="'vivid'"
    (pieChartSelect)="onPieChartSelect($event)">
  </app-pie>

  <!-- Trend Analysis -->
  @if(hasTrendData()){
  <div class="section">
    <h3 class="section-title">
      <mat-icon>timeline</mat-icon>
      Performance Trends
    </h3>

    <!-- Trend Line Chart -->
    @if(trendLineData.length > 0){
    <div class="chart-container">
      <h4>Performance Trends Over Time</h4>
      <app-line-chart [ourMethodologyData]="trendLineData">
      </app-line-chart>
    </div>
    }

    <!-- Improvement Bar Chart -->
    @if(improvementBarData.length > 0){
    <div class="chart-container">
      <h4>Performance Improvements</h4>
      <app-bar-chart [groupedBarData]="improvementBarData">
      </app-bar-chart>
    </div>
    }

    <!-- Trend Table -->
    <div class="table-container">
      <h4>Trend Analysis Summary</h4>
      <app-table [dataSource]="trendTableData" [columns]="trendTableColumns"
        [displayedColumns]="getTrendTableColumns()">
      </app-table>
    </div>
  </div>
  }

  <!-- Improvement Analysis -->
  @if(hasImprovementData()){
  <div class="section">
    <h3 class="section-title">
      <mat-icon>improvement</mat-icon>
      Improvement Opportunities
    </h3>
    <app-table [dataSource]="improvementTableData" [columns]="improvementTableColumns"
      [displayedColumns]="getImprovementTableColumns()">
    </app-table>
  </div>
  }

  <!-- Performance Metrics Distribution -->
  @if(performanceMetrics.length > 0){
  <div class="section">
    <h3 class="section-title">
      <mat-icon>pie_chart</mat-icon>
      Performance Metrics Distribution - (You)
    </h3>
    <app-pie-grid [modelWiseScores]="performanceMetrics">
    </app-pie-grid>
  </div>
  }

  <!-- Overall Performance Summary -->
  <!-- @if(hasOverallPerformanceSummary()){
  <div class="section">
    <h3 class="section-title">
      <mat-icon>assessment</mat-icon>
      Overall Performance Summary
    </h3>
    <div class="summary-content">
      @if(overallPerformanceSummary.title){
      <h4>{{ overallPerformanceSummary.title }}</h4>
      }
      @if(overallPerformanceSummary.description){
      <p class="summary-text">{{ overallPerformanceSummary.description }}</p>
      }
      @if(overallPerformanceSummary.total_universities_analyzed ||
      overallPerformanceSummary.average_performance_score){
      <div class="key-metrics">
        <h4>Key Metrics</h4>
        <div class="metrics-grid">
          @if(overallPerformanceSummary.total_universities_analyzed){
          <div class="metric-card">
            <div class="metric-name">Universities Analyzed</div>
            <div class="metric-value">{{ overallPerformanceSummary.total_universities_analyzed }}</div>
            <div class="metric-description">Total number of universities in analysis</div>
          </div>
          }
          @if(overallPerformanceSummary.average_performance_score){
          <div class="metric-card">
            <div class="metric-name">Average Performance Score</div>
            <div class="metric-value">{{ overallPerformanceSummary.average_performance_score.toFixed(1) }}
            </div>
            <div class="metric-description">Overall average performance across all metrics</div>
          </div>
          }
          @if(overallPerformanceSummary.performance_distribution){
          <div class="metric-card">
            <div class="metric-name">Performance Distribution</div>
            <div class="metric-value">{{ overallPerformanceSummary.performance_distribution.excellent +
              overallPerformanceSummary.performance_distribution.good }}</div>
            <div class="metric-description">Excellent & Good performers</div>
          </div>
          }
        </div>
      </div>
      }
    </div>
  </div>
  } -->

  <!-- Tracking Methodology
  @if(hasTrackingMethodology()){
  <div class="section">
    <h3 class="section-title">
      <mat-icon>science</mat-icon>
      Tracking Methodology
    </h3>
    <div class="methodology-content">
      @if(trackingMethodology.data_collection || trackingMethodology.analysis_frequency ||
      trackingMethodology.benchmarking || trackingMethodology.reporting){
      <div class="methodology-metrics">
        <h4>Methodology Components</h4>
        <ul class="metrics-list">
          @if(trackingMethodology.data_collection){
          <li><strong>Data Collection:</strong> {{ trackingMethodology.data_collection }}</li>
          }
          @if(trackingMethodology.analysis_frequency){
          <li><strong>Analysis Frequency:</strong> {{ trackingMethodology.analysis_frequency }}</li>
          }
          @if(trackingMethodology.benchmarking){
          <li><strong>Benchmarking:</strong> {{ trackingMethodology.benchmarking }}</li>
          }
          @if(trackingMethodology.reporting){
          <li><strong>Reporting:</strong> {{ trackingMethodology.reporting }}</li>
          }
        </ul>
      </div>
      }
    </div>
  </div>
  }

  Analysis Details
  @if(hasDetails()){
  <div class="section">
    <h3 class="section-title">
      <mat-icon>analytics</mat-icon>
      Analysis Details
    </h3>
    <div class="details-content">
      @if(details.summary){
      <p class="details-summary">{{ details.summary }}</p>
      }
      @if(details.key_findings){
      <div class="key-findings">
        <h4>Key Findings</h4>
        <ul class="findings-list">
          @for(finding of details.key_findings; track finding){
          <li>{{ finding }}</li>
          }
        </ul>
      </div>
      }
      @if(details.methodology){
      <div class="analysis-methodology">
        <h4>Analysis Methodology</h4>
        <p>{{ details.methodology }}</p>
      </div>
      }
    </div>
  </div>
  } -->

  <!-- Evidence Sources -->
  @if(hasEvidenceSources()){
  <div class="section">
    <h3 class="section-title">
      <mat-icon>source</mat-icon>
      Performance Data Sources
    </h3>
    <div class="evidence-capsules">
      @for(evidence of evidenceSources; track evidence.url){
      <div class="evidence-capsule" 
           [matTooltip]="getEvidenceTooltip(evidence)" 
           matTooltipPosition="above"
           matTooltipClass="evidence-tooltip"
           (click)="openSourceLink(evidence.url)"
           [title]="'Click to view source: ' + evidence.url">
        {{ evidence.source }}
      </div>
      }
    </div>
  </div>
  }

  <!-- Recommendations -->
  @if(hasRecommendations()){
  <div class="section">
    <h3 class="section-title">
      <mat-icon>lightbulb</mat-icon>
      Performance Improvement Recommendations
    </h3>
    <div class="recommendations-grid">
      @for(rec of recommendations; track rec.category){
      <mat-card class="recommendation-card" [class]="'priority-' + rec.priority.toLowerCase()">
        <mat-card-header>
          <mat-card-title>{{ rec.issue }}</mat-card-title>
          <mat-card-subtitle>
            <span class="recommendation-category">{{ rec.category }}</span>
            <span class="recommendation-priority" [class]="'priority-' + rec.priority.toLowerCase()">
              {{ rec.priority }}
            </span>
          </mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
          <p class="recommendation-text">{{ rec.recommendation }}</p>
          <div class="recommendation-impact">
            <mat-icon>trending_up</mat-icon>
            <span>{{ rec.expected_impact }}</span>
          </div>
        </mat-card-content>
      </mat-card>
      }
    </div>
  </div>
  }

  <!-- No Data Message -->
  @if(!hasPerformanceData() && !hasTrendData()){
  <div class="no-data-message">
    <mat-icon>trending_up</mat-icon>
    <h3>No Performance Tracking Data Available</h3>
    <p>Please select universities and try again.</p>
  </div>
  }
</div>